import React from "react";
import abImg from "../../images/about-s2.webp"; // Replace with Taisha's actual image
import icon1 from "../../images/about-icon-1.png";
import icon2 from "../../images/about-icon-2.png";

const About = (props) => {
  return (
    <section className="wpo-about-section-s2 section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <img src={abImg} alt="Taisha St. Jean Tard" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                <span>About Taisha</span>
                <h2>Dedicated to Building a Better Buffalo</h2>
              </div>
              <p className="sub-text">
                Taisha St. Jean Tard has spent her life advocating for Western
                New York. She believes real progress comes from listening to
                people, working in collaboration, and finding solutions to
                everyday challenges. Her priorities are clear: transparency,
                expanding economic opportunities, and making life better for
                everyone in the community she loves.
              </p>{" "}
              <p />
              <p className="sub-text">
                As a Buffalo native, Taisha is committed to the community she
                loves. She graduated from Leonardo da Vinci High School in 2013,
                earned her Communication degree from Medaille College, and a
                Master’s in Marketing Communication at St. Bonaventure
                University. She’s been honored with Business First’s “30 Under
                30” and the Grassroots “Rising Star” Award for her leadership
                and dedication to her community.
              </p>
              <p />
              <p className="sub-text">
                In her role as Chief of Staff for the Buffalo Common Council,
                Taisha works alongside community leaders to make meaningful
                change happen. Whether it’s improving neighborhoods, supporting
                families, or shaping policies, she’s always been focused on
                results. Her experience as a college professor and as Executive
                Director of the Miss Buffalo Scholarship Organization highlights
                her lifelong passion for education and creating opportunities
                for our future leaders.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
